import styled from 'styled-components';
import { Container } from '@mui/material';
import { themeOptions } from 'styles';

export const StyledStikyGroupTable = styled.div`
  .groupHeaderStyle {
    border-left: 1px solid rgba(224, 224, 224, 1);
    border-right: 1px solid rgba(224, 224, 224, 1);
  }
  .groupBodyStyle {
    border-left: 1px solid rgba(224, 224, 224, 1);
    border-right: 1px solid rgba(224, 224, 224, 1);
  }

  /* 테이블 컨테이너에 대한 스타일 */
  .MuiTableContainer-root {
    overflow-x: scroll; /* 가로 스크롤 활성화 */
    width: 100%; /* 컨테이너 너비를 100%로 설정 */

    /* 가로 스크롤바 스타일 */
    &::-webkit-scrollbar {
      width: 0; /* 스크롤바 너비 조절 */
      height: 12px;
      border-radius: 6px;
    }

    /* 스크롤바 트랙 스타일 */
    &::-webkit-scrollbar-track {
      background: #fff; /* 스크롤바 트랙 배경색 */
    }

    /* 스크롤바 슬라이더(손잡이) 스타일 */
    &::-webkit-scrollbar-thumb {
      background: #e8eaec; /* 스크롤바 슬라이더 색상 */
    }

    /* 스크롤바 슬라이더 호버 스타일 */
    &::-webkit-scrollbar-thumb:hover {
      background: #555; /* 스크롤바 슬라이더 호버 색상 */
    }
  }

  /* 테이블 헤더에 대한 스타일 */
  .MuiTableHead-root {
    /* white-space: nowrap; 줄 바꿈 방지 */
  }

  .MuiPaper-root {
    box-shadow: none;
    border-radius: 0;
    border-top: 1px solid #dadada;
  }
  //Table Header
  .MuiTableCell-head {
    height: 40px;
    padding: 11px 0;
    color: #222222;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    text-align: center;
    background-color: ${themeOptions.palette.gray.light};
  }

  //Table Body
  .MuiTableCell-body {
    height: 40px;
    padding: 11px 0;
    color: ${themeOptions.palette.gray.dark};
    text-align: center !important;
  }

  .MuiTablePagination-root {
    border-bottom: none;
    padding: 0 !important;

    .MuiTablePagination-toolbar {
      padding: 0 !important;

      .MuiInputBase-root {
        margin-right: 0 !important;
        border-radius: 4px;
        border: 1px solid #dadada;
      }
    }
  }

  .MuiTablePagination-displayedRows {
    display: none;
  }

  .MuiTablePagination-actions {
    display: none;
  }

  .table-pagination {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    &.absolute-bottom {
      position: absolute;
      bottom: 50px;
      right: 10px;
    }
  }
`;

export const StyledStickyPagination = styled.div`
  .MuiTablePagination-input {
    margin-left: 12px;
    padding: 0;
    .MuiTablePagination-select {
      padding: 6px 30px 6px 16px;
    }
  }
  .MuiPaginationItem-text.Mui-selected {
    height: 32px;
    font-size: 14px;
    font-weight: 500;
    color: ${themeOptions.palette.white.main};
    background-color: ${themeOptions.palette.green.main};
  }
`;

export const TableContainer = styled(Container)`
  width: 100%;
  overflow-x: auto;
`;
